export var EBehavior;

(function (EBehavior) {
  EBehavior["Multiply"] = "multiply";
  EBehavior["Single"] = "single";
  EBehavior["SingleInOneGroup"] = "singleInOneGroup";
})(EBehavior || (EBehavior = {}));